export const LabelText = {
  Status: {
    Active: 'Active',
    Invited: 'Invited'
  },
  Cta: {
    Unlink: 'Unlink Personal Account',
    ResendInvite: 'Resend Invite'
  }
};
